const oursAboutPegasus = {
  title: 'НАШ ПІДХІД',
  cards: {
    reliability: {
      title: 'НАДІЙНІСТЬ',
      description:
        'Кожен БпЛА перевіряється перед передачею у підрозділи.',
    },
    fast: {
      title: 'ШВИДКІСТЬ ВПРОВАДЖЕННЯ',
      description: 'Від ідеї до серійного запуску — лічені місяці.',
    },
    stability: {
      title: 'СТІЙКІСТЬ ДО РЕБ',
      description:
        'Ми проєктуємо рішення, здатні працювати в найскладніших умовах.',
    },
    locked: {
      title: 'ЗАМКНЕНА ЕКОСИСТЕМА',
      description:
        'Від R&D і виробництва до навчання операторів БпЛА/БпАК і техпідтримки 24/7.',
    },
  },
}

export default oursAboutPegasus
